import { useContactsCheckExistContactDialogQuery } from './api/repositories/use-check-exist-contact-dialog.query';
import { useContactsInitContactDialogMutation } from './api/repositories/use-contacts-init-contact-dialog.mutation';
import { useNewContactIframeModalContext } from './new-contact-iframe-modal-context';
import { ContactDialogReferenceType, CustomerData, InitContactDialogInput } from 'api-new/generated';

export const useNewContact = (
  customerData: CustomerData,
  referenceId: number,
  referenceType: ContactDialogReferenceType
) => {
  const { mutate: initContactDialog } = useContactsInitContactDialogMutation();
  const { mutate: checkExistContactDialog, isLoading: isChecking } = useContactsCheckExistContactDialogQuery();
  const { openConfirmDialogModal, openContactIframe } = useNewContactIframeModalContext();

  const handleCheckIfDialogExists = () => {
    if (isChecking) return;

    const requestBody: InitContactDialogInput = {
      customer: {
        title: customerData.title ?? '',
        titleId: customerData.titleId,
        firstName: customerData.firstName ?? '',
        lastName: customerData.lastName ?? '',
        email: customerData.email ?? '',
        phone: customerData.phone ?? '',
        fullName: customerData.fullName ?? ''
      },
      referenceId: referenceId,
      referenceType: referenceType
    };

    checkExistContactDialog(
      {
        requestBody: requestBody
      },
      {
        onSuccess(response) {
          if (!response) {
            if (openConfirmDialogModal) openConfirmDialogModal(requestBody);
          } else {
            openIFrameModal(requestBody);
          }
        }
      }
    );

    const openIFrameModal = (data: InitContactDialogInput) => {
      initContactDialog(
        {
          requestBody: data
        },
        {
          onSuccess(response: number) {
            if (openContactIframe) {
              openContactIframe({ contactId: response });
            }
          }
        }
      );
    };
  };

  return { handleCheckIfDialogExists };
};
